// French. Machine-drafted — review with a native speaker before launch.
import type { TranslationDictionary } from './en';

const fr: TranslationDictionary = {
	language: {
		label: 'Langue',
		en: 'Anglais',
		es: 'Espagnol',
		fr: 'Français',
		ar: 'Arabe',
	},
	help: {
		helpMenu: 'Aide',
		requestFeature: 'Proposer une fonctionnalité',
		helpDocs: 'Documentation',
		contactSupport: 'Contacter le support',
	},
	nav: {
		dashboard: 'Tableau de bord',
		cards: 'Cartes',
		videoCards: 'Cartes vidéo',
		engagement: 'Engagement',
		settings: 'Paramètres',
		createNewCard: 'Créer une carte',
	},
	common: {
		save: 'Enregistrer',
		cancel: 'Annuler',
		delete: 'Supprimer',
		edit: 'Modifier',
		search: 'Rechercher',
		loading: 'Chargement…',
		download: 'Télécharger',
		share: 'Partager',
		close: 'Fermer',
		back: 'Retour',
		next: 'Suivant',
	},
	viewcard: {
		header: 'Bonjour %{name}, %{sender} vous a créé une carte numérique.',
		hi: 'Bonjour',
		youHaveACard: 'Vous avez une carte !',
		tapEnvelopeToOpen: "Touchez l'enveloppe pour l'ouvrir",
		sentYouACard: '%{sender} vous a envoyé une carte',
		tapToOpen: '👆 Touchez pour ouvrir',
		tapOrSwipeToFlip: '👆 Touchez ou glissez pour tourner la carte 👉',
		clickToOpen: 'Cliquez sur la carte pour l’ouvrir.',
		tapToFlip: 'Touchez la carte pour la retourner.',
		postcardFront: "Recto de la carte postale. Appuyez pour la retourner.",
		postcardBack: "Verso de la carte postale. Appuyez pour la retourner.",
		createYourOwn: 'Créez votre propre carte gratuite',
		scrollToReact: 'Faites défiler pour réagir et commenter ↓',
		reactToThisCard: 'Réagissez à cette carte',
		comments: 'Commentaires',
		leaveComment: 'Laissez un commentaire',
		yourName: 'Votre nom',
		writeMessage: 'Écrivez un message… (500 caractères max)',
		post: 'Publier',
		postAnonymously: 'Publier anonymement',
		shareToWhatsapp: 'Partager sur WhatsApp',
		copyLink: 'Copier le lien',
		linkCopied: 'Lien copié !',
		shareViaEmail: 'Partager par e-mail',
		shareOnX: 'Partager sur X',
	},
	music: {
		play: 'Lancer la musique',
		pause: 'Mettre en pause',
		volume: 'Volume',
	},
	promo: {
		headline: 'Ajoutez un message vidéo à vos cartes.',
		subline: 'Qu’ils vous voient et vous entendent, au lieu de simplement vous lire. Un seul paiement, sans abonnement.',
		cta: 'Accès à vie',
		daysLeft: '%{count} jours restants',
		lastDay: 'Dernier jour',
	},
	unsub: {
		title: 'Préférences d’e-mail',
		confirmHeading: 'Se désabonner de ces e-mails ?',
		confirmBody: 'Vous ne recevrez plus de cartes ni d’e-mails de cet expéditeur. Rien d’autre ne change.',
		confirmButton: 'Oui, me désabonner',
		keepButton: 'Non, rester abonné',
		processing: 'Mise à jour de vos préférences…',
		successHeading: 'Vous êtes désabonné',
		successBody: 'Vous ne recevrez plus ces e-mails.',
		successNote: 'Vous avez changé d’avis ? Contactez directement l’expéditeur pour qu’il vous réinscrive.',
		keptHeading: 'Vous êtes toujours abonné',
		keptBody: 'Aucune modification n’a été effectuée. Vous pouvez fermer cette page.',
		errorHeading: 'Une erreur est survenue',
		errorBody: 'Nous n’avons pas pu traiter votre demande. Veuillez réessayer dans un instant.',
		errorMissing: 'Ce lien de désabonnement est incomplet. Veuillez utiliser le lien de votre e-mail.',
		tryAgain: 'Réessayer',
	},
};

export default fr;
